import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=e7b35608"
import script from "./CardFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardFooter.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports